export default __webpack_public_path__ + "static/media/738.16aee834.png";